var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticClass: "home-wrapper",
      style: { backgroundImage: `url(${_vm.backgroundImage})` },
      attrs: { fluid: "" },
    },
    [
      _c(
        "v-row",
        {
          staticClass: "home-cont",
          class: _vm.isMobileOrTablet
            ? _vm.pageWidth > 600
              ? "padTop10"
              : _vm.pageHeight < 731
              ? "padTop30"
              : "padTop70"
            : _vm.pageWidth > 1600
            ? ""
            : "",
          attrs: { justify: "center" },
        },
        [
          _c("RiskInsiderButton"),
          _c("PriceGuardButton"),
          _c("TradeWatcherButton"),
          _c("PriceWatcherButton"),
          _c("DashboardButton"),
          _c("BIAnalyticsButton"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }